import axiosInstance from "../../interceptor/intercetptor-inctence"


export const inventoryAdjustment = (data) => {
	return axiosInstance.post(`pharma/add-inventory`, data)
}

export const getInventoryHistory = (data) => {
	return axiosInstance.post(`pharma/get-inventory`, data)
}

export const viewAdjustment = (data) => {
	return axiosInstance.post(`pharma/view-inventory-details`, data)
}